'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ViewRetailPriceListController = function () {
  function ViewRetailPriceListController(authService, loadingService, retailPriceListService, $q, enums, lookupService, $window, $ngConfirm, growl) {
    "ngInject";

    var _this = this;

    (0, _classCallCheck3.default)(this, ViewRetailPriceListController);
    if (!authService.authData.isAdmin) {
      return;
    }

    this.loadingService = loadingService;
    this.retailPriceListService = retailPriceListService;
    this.$q = $q;
    this.enums = enums;
    this.lookupService = lookupService;
    this.$window = $window;
    this.$ngConfirm = $ngConfirm;
    this.growl = growl;

    this.filterParams = {};

    this.initializeLookups().then(function () {
      _this.reset();
    });
  }

  (0, _createClass3.default)(ViewRetailPriceListController, [{
    key: 'initializeLookups',
    value: function initializeLookups() {
      var _this2 = this;

      var ctrl = this;
      var deferred = ctrl.$q.defer();

      this.lookupService.lookupBrands().then(function (brands) {
        brands[0].name = 'All Brands';
        _this2.brands = brands;
        _this2.filterParams.brand = _this2.brands[0];

        _this2.lookupService.lookupBrandModels().then(function (brandModels) {
          _this2.allBrandModels = brandModels;
          _this2.updateBrandModel();
          deferred.resolve();
        });
      });

      return deferred.promise;
    }
  }, {
    key: 'updateBrandModel',
    value: function updateBrandModel() {
      var _this3 = this;

      this.brandModels = (0, _lodash.filter)(this.allBrandModels, function (o) {
        return o.brandId === _this3.filterParams.brand.brandId;
      });
      this.brandModels = [{ brandModelId: 0, name: 'All Models' }].concat((0, _toConsumableArray3.default)(this.brandModels));
      this.filterParams.brandModel = this.brandModels[0];
    }
  }, {
    key: 'reset',
    value: function reset() {
      var ctrl = this;

      this.filterParams.brand = this.brands[0];
      this.filterParams.brandModel = this.brandModels[0];
      this.filterParams.variant = null;

      this.pagination = {
        totalItems: 0,
        currentPage: 1,
        pageSize: 10
      };

      this.filterParams.pageCriteria = {
        pageStart: 0,
        itemsToFetch: this.pagination.pageSize,
        sortExpression: 'lastUpdated',
        ascending: false
      };

      this.notification = {
        type: 'info',
        msg: ''
      };

      this.viewAllRetailPriceList();
    }
  }, {
    key: 'updatePageIndex',
    value: function updatePageIndex() {
      if (this.pagination.currentPage === 1) {
        this.filterParams.pageCriteria.pageStart = 0;
      } else {
        this.filterParams.pageCriteria.pageStart = (this.pagination.currentPage - 1) * this.pagination.pageSize;
      }
    }
  }, {
    key: 'updateSort',
    value: function updateSort(fieldName) {
      if (this.filterParams.pageCriteria.sortExpression === fieldName) {
        this.filterParams.pageCriteria.ascending = !this.filterParams.pageCriteria.ascending;
      } else {
        this.filterParams.pageCriteria.sortExpression = fieldName;
        this.filterParams.pageCriteria.ascending = true;
      }

      this.viewAllRetailPriceList();
    }
  }, {
    key: 'viewAllRetailPriceList',
    value: function viewAllRetailPriceList() {
      var ctrl = this;

      ctrl.updatePageIndex();

      ctrl.loadingService.showLoading('retailPriceList', 'Loading All Retail Price List');

      ctrl.retailPriceListService.listRetailPriceList(ctrl.filterParams).then(function (response) {
        ctrl.retailPriceList = response.data.items;
        ctrl.pagination.totalItems = response.data.totalRecords;

        if (ctrl.pagination.totalItems === 0) {
          ctrl.notification = {
            type: 'info',
            msg: 'No data to display'
          };
        } else {
          var pageEnd = ctrl.filterParams.pageCriteria.pageStart + ctrl.pagination.pageSize < response.data.totalRecords ? ctrl.filterParams.pageCriteria.pageStart + ctrl.pagination.pageSize : response.data.totalRecords;

          ctrl.notification = {
            type: 'info',
            msg: 'Currently display ' + (ctrl.filterParams.pageCriteria.pageStart + 1) + ' to ' + pageEnd + ' out of ' + ctrl.pagination.totalItems + ' vehicles'
          };
        }
      }).catch(function (err) {}).finally(function () {
        ctrl.loadingService.hideLoading('retailPriceList');
      });
    }
  }, {
    key: 'deleteRetailPriceList',
    value: function deleteRetailPriceList(retailPriceListId) {
      var _this4 = this;

      var ctrl = this;
      var sure = void 0,
          state = void 0;

      sure = this.$window.confirm('Are you sure you want to delete this Retail Price List ?');

      if (!sure) {
        return;
      }

      this.loadingService.showLoading('retailPriceList', 'Removing Retail Price List ...');

      ctrl.retailPriceListService.updateState(retailPriceListId, this.enums.OBJECT_ROW_STATE.Deleted).then(function (response) {
        ctrl.viewAllRetailPriceList();
      }).catch(function (err) {
        ctrl.notification = {
          type: 'error',
          msg: "An error occurred while updating retail price state state. " + err.data.messageDetail ? err.data : err.data.messageDetail
        };
      }).finally(function () {
        _this4.loadingService.hideLoading('retailPriceList');
      });
    }
  }, {
    key: 'clear',
    value: function clear() {
      var _this5 = this;

      this.$ngConfirm({
        title: 'Clear Price List',
        content: 'This will delete all existing retail price entries. </br></br> <b>Are you sure you want to continue ?</b>',
        type: 'orange',
        typeAnimation: false,
        columnClass: 'm',
        buttons: {
          yes: {
            text: 'Yes',
            btnClass: 'btn-primary',
            action: function action() {
              _this5.retailPriceListService.clear().then(function () {
                _this5.growl.success('Retail Price Lists cleared successfully', { ttl: 5000 });
                _this5.reset();
              });
            }
          },
          no: {
            text: 'No',
            btnClass: 'btn-default'
          }
        }
      });
    }
  }]);
  return ViewRetailPriceListController;
}();

exports.default = ViewRetailPriceListController;


// WEBPACK FOOTER //
// ./client/app/components/admin/retailPriceList/viewRetailPriceList/viewRetailPriceList.controller.js